<app-header></app-header>
<div class="container-fluid pb-5">
  <router-outlet></router-outlet>
  <button (click)="openModal()" class="help-icon text-center" type="button">
    <div>
      <fa-icon [icon]="['fas','comment']"></fa-icon>
    </div>
    <div class="font-weight-normal text-capitalize text-center">{{'common.help' | translate}}</div>
  </button>
</div>
<app-footer></app-footer>
